import Notifications, { notes } from "@phoenixreisen/mithrils/src/notification";
import Footer from "../../../shared/footer/footer.intern.m";
import Header from "../../../shared/header/header.m";
import m from "mithril";
export const PageLayout = {
    view({ attrs, children }) {
        const { noWrapper } = attrs;
        return [
            m(Header, { key: "header", noImg: true, noNav: false, version: "PHX Workspace", headline: m("span", null,
                    m("i", { class: "fas fa-map-signs mr3" }),
                    "Phoenix Workspace") }),
            m("div", { key: "content", class: !noWrapper && "wrapper wrapper--large pv0" }, children),
            m(Footer, { key: "footer" }),
            m(Notifications, { key: "notes", list: notes }),
        ];
    },
};
export default PageLayout;
